import React, { useEffect, useState, Dispatch } from 'react';
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Tabs,
  notification,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2';
import {
  CriarCadVeiculoService,
  getVeiculos,
} from '../../../../../cadastros/cadastroVeiculo/services/cadVeiculoServices';
import moment from 'moment';
import { ApplicationState } from '../../../../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../../../store/ducks/listarVeiculos/actions';
import { IListarVeiculos } from '../../../../../../store/ducks/listarVeiculos/types';
import { getVeiculosPortal } from './services';
import mask from '../../../../../../utils/mask';
import { TextLabel } from 'components/TextLabel';
import TitlePage from 'components/TitlePage';
import { placaValidation } from 'utils/validator';

interface Props {
  setSelectedVeiculo?: any;
  disabled: boolean;
  props?: any;
  codParceiro?: number | null;
  clienteRetira?: boolean;
  setCodTipValue: React.Dispatch<React.SetStateAction<number | null>>;
  setAssoalho: React.Dispatch<React.SetStateAction<string>>;
}

const ModalVeiculo: React.FC<Props> = ({
  disabled,
  setSelectedVeiculo,
  props = [],
  setCodTipValue,
  setAssoalho,
}) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const [formSelect] = Form.useForm();
  const { TabPane } = Tabs;
  const dispatch = useDispatch<Dispatch<Action>>();
  const transportadoras = useSelector((state: ApplicationState) => state.Transportadoras.data);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [tabsSelect, setTabsSelect] = useState<string>('1');
  const [value, setValue] = useState<string>(props.placa);
  const [anoFabricacao, setAnoFabricacao] = useState<any>();
  const [responseTipoVeiculos, setResponseTipoVeiculos] = useState<any>();
  const [selectAssoalho, setSelectAssoalho] = useState<boolean>(false);

  const [veiculo, setVeiculo] = useState<IListarVeiculos[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    getVeiculosPortal
      .getVeiculosPortal(inscricaoAtiva)
      .then((res) => {
        setVeiculo(res?.data?.veiculos);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [dispatch, inscricaoAtiva]);

  useEffect(() => {
    try {
      getVeiculos.getTipoVeiculos().then((res) => {
        setResponseTipoVeiculos(res.data.tiposVeiculos);
      });
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar a lista de veículos, por favor tente novamente!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }, []);

  const onFinish = (values: any) => {
    setCodTipValue(values?.codTip);
    setValue(values?.codVeiculo?.split(' ')[1]);
    setSelectedVeiculo(+values?.codVeiculo?.split(' ')[0]);
    setIsModalVisible(false);
    formSelect.resetFields();
  };

  const handleOk = (values: any) => {
    if (tabsSelect === '1') {
      setIsModalVisible(false);
      formSelect.resetFields();
    }

    if (tabsSelect === '2') {
      const isValide = placaValidation(values.placa);

      if (!isValide) {
        return notification.error({
          message: 'Placa inválida',
          placement: 'bottomRight',
        });
      }

      form.validateFields().then(async (e) => {
        const veiculo = {
          placa: values.placa,
          ano: anoFabricacao,
          codParcTransp: values.codParcTransp,
        };

        try {
          await CriarCadVeiculoService.criaAlteraVeiculoPortal(veiculo, inscricaoAtiva).then(
            (res) => {
              setValue(res.data.veiculo.placa);
              setSelectedVeiculo(res.data.veiculo.codVeiculo);
              Swal.fire({
                title: 'Veículo cadastrado com sucesso!',
                html: '',
                icon: 'success',
                showConfirmButton: false,
                timer: 1500,
              });
            }
          );
          setAssoalho(values?.assoalho);
          setCodTipValue(values.codTip);
          dispatch(loadRequest(inscricaoAtiva));
        } catch (error: any) {
          if (error.response.data.Erro) {
            Swal.fire({
              title: 'Opss...',
              html: `${error.response?.data?.Erro}`,
              icon: 'warning',
            });
          } else {
            Swal.fire({
              title: 'Não foi possível cadastrar o veículo!',
              html: '',
              icon: 'error',
              showConfirmButton: false,
              timer: 1500,
            });
          }
        } finally {
          setIsModalVisible(false);
          form.resetFields();
        }
      });
    }
  };
  const disabledDate = (current: any) => {
    return current && current > moment().startOf('day');
  };

  const handleSelectAssoalho = (codTip: number) => {
    const tipVeiculo = responseTipoVeiculos.find((veiculo: any) => veiculo.codTip === codTip);
    setSelectAssoalho(tipVeiculo.exigeAssoalho);
  };

  return (
    <>
      <Modal
        centered
        title={<TitlePage>Veículos</TitlePage>}
        visible={isModalVisible}
        onCancel={() => {
          form.resetFields();
          setIsModalVisible(false);
        }}
        maskClosable={true}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={850}
        footer={[]}
      >
        <Tabs onChange={(e) => setTabsSelect(e)} defaultActiveKey="1">
          <TabPane tab="Veículos cadastrados" key="1">
            <Form form={formSelect} onFinish={onFinish}>
              {!loading ? (
                <Row gutter={24}>
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      style={{ display: 'table', width: '100%' }}
                      name="codVeiculo"
                      label={<TextLabel> Placa do veículo</TextLabel>}
                      rules={[{ required: true, message: 'Digite a Placa do veículo' }]}
                    >
                      <Select
                        showSearch
                        filterOption={(inputValue, element) =>
                          element?.props.children
                            .toString()
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                        placeholder="Selecione a placa do seu veículo"
                      >
                        {veiculo?.map((item: any) => (
                          <>
                            <Option
                              key={item.codVeiculo}
                              value={item.codVeiculo + ' ' + item.placa?.toUpperCase()}
                              style={{ fontWeight: 600 }}
                            >
                              {item.placa?.toUpperCase()}
                            </Option>
                          </>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      style={{ display: 'table', width: '100%' }}
                      name="codTip"
                      rules={[{ required: true, message: 'Selecione o tipo do veículo' }]}
                      label={<TextLabel>Tipo do veículo</TextLabel>}
                    >
                      <Select
                        placeholder="Selecione um tipo de veículo"
                        filterOption={(inputValue, element) =>
                          element?.props.children
                            .toString()
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                        showSearch
                        onSelect={(e) => {
                          handleSelectAssoalho(+e);
                          setCodTipValue(+e);
                        }}
                      >
                        {responseTipoVeiculos?.map((item: any) => {
                          return (
                            <Option
                              key={item.codTip}
                              value={item.codTip}
                              style={{ fontWeight: 600 }}
                            >
                              {mask('camelCase', item.nome)}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  {selectAssoalho && (
                    <Col md={8} sm={24} xs={24}>
                      <Form.Item
                        style={{ display: 'table', width: '100%' }}
                        name="assoalho"
                        rules={[
                          { required: true, message: 'Selecione o tipo do assoalho do veículo' },
                        ]}
                        label={<TextLabel>Tipo do assoalho</TextLabel>}
                      >
                        <Select
                          placeholder="Selecione o tipo do assoalho"
                          onSelect={(e) => setAssoalho(e?.toString())}
                        >
                          <Option value={'F'}>Ferro</Option>
                          <Option value={'M'}>Madeira</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              ) : (
                <LoadingOutlined />
              )}
              <Col style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
                <Space>
                  <Button
                    type="default"
                    onClick={() => {
                      formSelect.resetFields();
                      setIsModalVisible(false);
                      setSelectAssoalho(false);
                    }}
                  >
                    Cancelar
                  </Button>

                  <Button type="primary" htmlType="submit" data-cy="btnOk">
                    OK
                  </Button>
                </Space>
              </Col>
            </Form>
          </TabPane>

          <TabPane tab="Novo veículo" key="2">
            <Form form={form} onFinish={handleOk}>
              <Row gutter={24}>
                <Col md={8} sm={24} xs={24}>
                  <Form.Item
                    style={{ display: 'table', width: '100%' }}
                    name="codParcTransp"
                    label={<TextLabel>Transportadora</TextLabel>}
                    rules={[{ required: true, message: 'Selecione a transportadora' }]}
                  >
                    <Select
                      placeholder="Selecione uma transportadora"
                      filterOption={(inputValue, element) =>
                        element?.props.children
                          .toString()
                          .toLowerCase()
                          .replace(/\.|-|\//g, '')
                          .includes(inputValue.replace(/\.|-|\//g, '').toLowerCase())
                      }
                      showSearch
                    >
                      {transportadoras.map((item: any, index: number) => {
                        return (
                          <Option key={item?.codParceiro + index} value={item?.codParceiro}>
                            {mask('camelCase', item?.nomeParceiro)}
                            <br />
                            {mask('cpfCnpj', item?.cnpj)}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col md={8} sm={24} xs={24}>
                  <Form.Item
                    style={{ display: 'table', width: '100%' }}
                    name="placa"
                    label={<TextLabel>Placa do veículo</TextLabel>}
                    rules={[{ required: true, message: 'Digite a Placa do veículo' }]}
                  >
                    <Input type="text" min={0} maxLength={7} style={{ width: '100%' }} />
                  </Form.Item>
                </Col>

                <Col md={8} sm={24} xs={24}>
                  <Form.Item
                    style={{ display: 'table', width: '100%' }}
                    name="ano"
                    label={<TextLabel>Ano de fabricação</TextLabel>}
                  >
                    <DatePicker
                      onChange={(date: any, dateString: any) => {
                        setAnoFabricacao(+dateString);
                      }}
                      disabledDate={disabledDate}
                      style={{ width: '100%' }}
                      picker="year"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col md={8} sm={24} xs={24}>
                  <Form.Item
                    style={{ display: 'table', width: '100%' }}
                    name="codTip"
                    rules={[{ required: true, message: 'Selecione o tipo do veículo' }]}
                    label={<TextLabel>Tipo do veículo</TextLabel>}
                  >
                    <Select
                      placeholder="Selecione um tipo de veículo"
                      filterOption={(inputValue, element) =>
                        element?.props.children
                          .toString()
                          .toLowerCase()
                          .includes(inputValue.toLowerCase())
                      }
                      onSelect={(e) => {
                        handleSelectAssoalho(+e);
                      }}
                      showSearch
                    >
                      {responseTipoVeiculos?.map((item: any, index: number) => {
                        return (
                          <Option key={item.codTip} value={item.codTip} style={{ fontWeight: 600 }}>
                            {mask('camelCase', item.nome)}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>

                {selectAssoalho && (
                  <Col md={8} sm={24} xs={24}>
                    <Form.Item
                      style={{ display: 'table', width: '100%' }}
                      name="assoalho"
                      rules={[
                        { required: true, message: 'Selecione o tipo do assoalho do veículo' },
                      ]}
                      label={<TextLabel>Tipo do assoalho</TextLabel>}
                    >
                      <Select placeholder="Selecione o tipo do assoalho">
                        <Option value={'F'}>FERRO</Option>
                        <Option value={'M'}>MADEIRA</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                )}
              </Row>
              <Col style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
                <Space>
                  <Button
                    type="default"
                    onClick={() => {
                      form.resetFields();
                      setIsModalVisible(false);
                      setSelectAssoalho(false);
                    }}
                  >
                    Cancelar
                  </Button>

                  <Button type="primary" htmlType="submit">
                    OK
                  </Button>
                </Space>
              </Col>
            </Form>
          </TabPane>
        </Tabs>
      </Modal>
      <Button
        data-cy="veiculo"
        style={{
          width: '100%',
        }}
        title={`${value}`}
        type="dashed"
        onClick={() => setIsModalVisible(true)}
        disabled={disabled}
      >
        <span
          style={{
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {!value ? <span style={{ color: '#bbb' }}>Selecione um veículo</span> : value}
        </span>
      </Button>
    </>
  );
};

export default ModalVeiculo;
